<template>
    <section class="py-6 -mx-2">
        <div class="" v-if="item && item.answerType">
            <div class="container">
                <div v-if="item.imageUrl" class="columns">
                    <div class="column">
                        <figure class="image is-16by9">
                            <img :src="item.imageUrl" alt="">
                        </figure>
                    </div>
                </div>

                <section>
                    <div class="columns">
                        <div class="column ">
                            <div class="content is-medium">
                                <h2 class="subtitle is-4">{{ item.question }}</h2>
<!--                                <p>{{ item.question }}</p>-->
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column ">
                            <div class="content is-medium">
                                <template v-if="item.answerType === TYPE_MULTIPLE">
                                    <b-field v-for="option in options">
                                        <b-checkbox v-model="innerValue" :name="item.id" :native-value="option.id">
                                            {{ option.text }}
                                        </b-checkbox>
                                    </b-field>
                                </template>
                                <template v-if="item.answerType === TYPE_SINGLE">
                                    <b-field v-for="option in options">
                                        <b-radio v-model="innerValue" :name="item.id" :native-value="option.id">
                                            {{ option.text }}
                                        </b-radio>
                                    </b-field>
                                </template>
                                <template v-if="item.answerType === TYPE_MULTIPLE_SEQUENCE">
                                    <div class="mb-5">
                                        <b-field v-for="option in options">
                                            <b-checkbox v-model="innerValue" :name="item.id" :native-value="option.id">
                                                {{ option.text }}
                                            </b-checkbox>
                                        </b-field>
                                    </div>

                                    <div>
                                        <draggable v-model="innerValue">
                                            <transition-group>
                                                <b-field v-for="(it, i) in innerValue" :key="i" class="is-clickable">
                                                    <b-tag
                                                        type="is-success"
                                                        closable
                                                        closeType='is-danger'
                                                        aria-close-label="Close tag"
                                                        class="tag__custom"
                                                        @close="remove(i)">
                                                        {{i+1}}. {{ optionTitleById(it) }}
                                                    </b-tag>
                                                </b-field>
                                            </transition-group>
                                        </draggable>
                                    </div>
                                </template>

                                <template v-if="item.answerType === TYPE_SINGLE_SEQUENCE">
                                    <div>
                                        <draggable v-model="innerValue">
                                            <transition-group>
                                                <b-field v-for="(it, i) in innerValue" :key="i" class="is-clickable">
                                                    <b-tag
                                                        type="is-success"
                                                        closable
                                                        closeType='is-danger'
                                                        class="tag__custom"
                                                        aria-close-label="Close tag"
                                                        @close="remove(i)">
                                                        {{ optionTitleById(it) }}
                                                    </b-tag>
                                                </b-field>
                                            </transition-group>
                                        </draggable>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </section>


            </div>
        </div>
        <div class="hero-body" v-else><b-loading v-model="loading" :is-full-page="false" /></div>
    </section>
</template>

<script>
import { remove, map, find } from 'lodash'
import draggable from 'vuedraggable'
import { TYPE_SINGLE_SEQUENCE ,TYPE_MULTIPLE_SEQUENCE, TYPE_SINGLE, TYPE_MULTIPLE} from '../../../../../store/models/questions/model'


export default {
    props: ['item', 'value'],
    components: {
        draggable,
    },
    data () {
        return {
            //val: [],
            innerValue: {},
            loading: true,
        }
    },
    created () {
        this.init()
    },
    computed: {
        options () {
            return this.item.options
        },
        optionTitleById () {
            return (id) => {
                return this.$_get(find(this.options, item => item.id === id), 'text')
            }
        },
        TYPE_SINGLE_SEQUENCE() {
            return TYPE_SINGLE_SEQUENCE
        },
        TYPE_MULTIPLE_SEQUENCE() {
            return TYPE_MULTIPLE_SEQUENCE
        },
        TYPE_SINGLE() {
            return TYPE_SINGLE
        },
        TYPE_MULTIPLE() {
            return TYPE_MULTIPLE
        },
        val: {
            set (val) {

                this.$emit('res', {
                    id: this.item.id,
                    value: val,
                })
            },
            get () {
                return this.value ? this.value : (this.item.answerType === TYPE_SINGLE ? '' : [])
            }
        }
    },
    methods: {
        init () {
            // if (this.item && this.item.answerType === TYPE_SINGLE_SEQUENCE) {
            //     this.val = map(this.options, 'id')
            // }
        },
        remove (ind) {
            remove(this.val, (n, i) => {
                return i !== ind
            })
        },
    },
    watch: {
        item: {
            deep: true,
            handler(val, old) {

                if (val.answerType && !old.answerType) {
                    this.init()
                }
            }
        },
        value: {
            immediate: true,
            deep: true,
            handler() {
                this.innerValue = this.value ? this.value : (this.item.answerType === TYPE_SINGLE ? '' : [])
            }
        },
        innerValue: {
            immediate: true,
            deep: true,
            handler() {
                this.$emit('res', {
                    id: this.item.id,
                    value: this.innerValue,
                })
            }
        }
    }

}
</script>
